module.exports = __webpack_public_path__ + "static/media/question-grade.926455aa.m4a";